import React from "react";
import SEO from '../services/SEO';
import { Button, Result } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';


const NotFound = () => {

	window.scrollTo(0, 0);
	let navigate = useNavigate();

	return(
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">Página não encontrada</h2>
			<br/>
			<hr/>
			<br/>
			<Result
				status="404"
				title="404"
				subTitle=""
				extra={<Button type="primary" onClick={()=>{navigate('/');}}>Voltar para a página inicial</Button>}
			/>
		</div>
	);
}


export default NotFound;